import { Component } from '@angular/core';

@Component({
  selector: 'wilson-datenschutz',
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.scss'],
  standalone: false,
})
export class DatenschutzComponent {}
